module.exports = __webpack_public_path__ + "static/img/pick_up_heading.13ac7a31.png";